import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box, Tooltip } from '@mui/material';

type Props = {
    readonlyReasons?: string[];
};
export const ColumnReadonlyIcon = ({ readonlyReasons }: Props) => {
    if (readonlyReasons == null || readonlyReasons.length === 0) {
        return null;
    }

    return (
        <Tooltip
            title={
                <Box
                    sx={{
                        marginTop: -1,
                        fontSize: 11,
                        fontWeight: 400
                    }}
                >
                    <p>This column is locked due to the following reasons:</p>
                    {readonlyReasons.map((reason, idx) => (
                        <Box key={idx}>
                            {idx + 1}. {reason}
                        </Box>
                    ))}
                </Box>
            }
        >
            <span>
                <LockOutlinedIcon sx={{ fontSize: '18px', color: 'rgba(0,0,0,.65)' }} />
            </span>
        </Tooltip>
    );
};
